import React from 'react';
import DrilldownOptionClass from '@/util/DrilldownOption';
import { DrilldownOption } from './DrilldownOption';

export const DrilldownOptions: React.FC<any> = ({ rowIndex, dataTable }) => {
  const options = dataTable
    .drilldownOptions()
    .sort(DrilldownOptionClass.sortFunc);

  return (
    <tr key={`${rowIndex}expanded`}>
      <td className="no-border" />
      <td colSpan={dataTable.headings().length} className="expanded-cell">
        <table className="expanded-row">
          <tbody>
            {options.map((option: DrilldownOptionClass, index: number) => (
              <DrilldownOption
                key={index}
                rowIndex={rowIndex}
                option={option}
                dataTable={dataTable}
              />
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
};
